import firebase from "./firebase";
import config from "../config.json";

// firebase.functions().useFunctionsEmulator('http://localhost:5000')

async function requestSign(url, name) {
  let requestSignFunction = firebase.functions().httpsCallable("requestSign");

  try {
    let result = await requestSignFunction({ url, name });
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function createDocument(document, answers) {
  let createFunction = firebase.functions().httpsCallable(`createDocument${config.uses_v2 ? '_v2' : ''}`);
  try {
    let result = await createFunction({
      documentId: document.id,
      template_id: document.id,
      answers,
      name: document.name,
      environment: config.env,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
}

async function createPreview(document, answers) {
  let createFunction = firebase.functions().httpsCallable(`createPreview${config.uses_v2 ? '_v2' : ''}`);
  try {
    let result = await createFunction({
      documentId: document.id,
      answers,
      environment: config.env,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
}

async function sendPasswordResetEmail(email, language) {
  let sendEmailFunction = firebase
    .functions()
    .httpsCallable("sendPasswordResetEmail");
  try {
    let result = await sendEmailFunction({
      email,
      language,
      partner: config.partner,
      app_name: config.name,
      app_suffix: config.copy_suffix || '',
      locales: config.locales,
      email_template_tag: config.email_template_tag || '',
      email_no_background: config.email_no_background || false,
      email_theme_color: config.email_theme_color || ''
    });
    return result;
  } catch (err) {
    return { error: err };
  }
  // let { email, language, partner, app_name } = body
}

async function requestSignature(data) {
  let requestSignFunction = firebase.functions().httpsCallable("requestSignature");

  try {
    let result = await requestSignFunction(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function requestSignatureDev(data) {
  let requestSignFunction = firebase.functions().httpsCallable("requestSignatureDev");

  try {
    let result = await requestSignFunction(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function checkVerificationCode(data) {
  let checkVerificationCodeFunc = firebase.functions().httpsCallable("checkVerificationCode");

  try {
    let result = await checkVerificationCodeFunc(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function assignUserTypeWithCode(code) {
  const assignFunction = firebase.functions().httpsCallable("assignUserTypeWithCode");

  try {
    let result = await assignFunction({ code });
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  } 
}

async function payment(data) {
  data.environment = config.env
  let paymentFunction = firebase.functions().httpsCallable("payment");

  try {
    let result = await paymentFunction(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function confirmPayment(data) {
  data.environment = config.env
  let confirmPaymentFunction = firebase.functions().httpsCallable("confirmPayment");

  try {
    let result = await confirmPaymentFunction(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function checkHasPaid(data) {
  data.environment = config.env
  let checkHasPaidFunction = firebase.functions().httpsCallable("checkHasPaid");

  try {
    let result = await checkHasPaidFunction(data);
    return result.data;
  } catch (err) {
    console.log(err);

    return { error: err };
  }
}

async function sendWelcomeEmail(data) {
  let sendEmailFunction = firebase
    .functions()
    .httpsCallable("sendWelcomeEmail");
  try {
    let result = await sendEmailFunction(data);
    return result;
  } catch (err) {
    return { error: err };
  }
  // let { email, language, partner, app_name } = body
}

async function fetchPartnerDetails() {
  const partnerDetailFunctions = firebase.functions().httpsCallable('fetch_partner_public_details')
  try {
    let result = await partnerDetailFunctions({
      partnerId: config.partner
    });
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

async function fetchEnterpriseData(number) {
  let fetchData = firebase
    .functions()
    .httpsCallable("fetchEnterpriseData");
  try {
    let result = await fetchData(number);
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

async function fetchEnterpriseAddress(number) {
  let fetchData = firebase
    .functions()
    .httpsCallable("fetchEnterpriseAddress");
  try {
    let result = await fetchData(number);
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

async function fetchEnterpriseDenominations(number) {
  let fetchData = firebase
    .functions()
    .httpsCallable("fetchEnterpriseDenominations");
  try {
    let result = await fetchData(number);
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

// Support - give feedback
async function giveFeedback(data) {
  let func = firebase
    .functions()
    .httpsCallable("giveFeedback");
  try {
    let result = await func(data);
    return result;
  } catch (err) {
    return { error: err };
  }
}

// Support - report a bug
async function reportBug(data) {
  let func = firebase
    .functions()
    .httpsCallable("reportBug");
  try {
    let result = await func(data);
    return result;
  } catch (err) {
    return { error: err };
  }
}

// Get file
async function getFile(data) {
  let func = firebase
    .functions()
    .httpsCallable("fetchFileAndConvertToBase64");
  try {
    let result = await func(data);
    return result;
  } catch (err) {
    return { error: err };
  }
}

// Fetch help articles 
async function fetchHelpArticles(data) {
  let func = firebase
    .functions()
    .httpsCallable("fetchHelpArticles");
  try {
    let result = await func(data);
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

// Fetch help categories 
async function fetchHelpCategories(data) {
  let func = firebase
    .functions()
    .httpsCallable("fetchHelpCategories");
  try {
    let result = await func(data);
    return result.data;
  } catch (err) {
    return { error: err };
  }
}

// Increment article read count
async function incrementHelpArticleReadCount() {
  let func = firebase
    .functions()
    .httpsCallable("incrementHelpArticleReadCount");
  try {
    let result = await func();
    return result;
  } catch (err) {
    return { error: err };
  }
}

// Download signed document
async function downloadSignedDocument(fileId) {
  let func = firebase
    .functions()
    .httpsCallable("downloadFileSignatureDev");
  try {
    let result = await func({ fileId });
    return result;
  } catch (err) {
    return { error: err };
  }
}

export {
  createDocument,
  createPreview,
  sendPasswordResetEmail,
  requestSign,
  requestSignature,
  payment,
  confirmPayment,
  checkVerificationCode,
  checkHasPaid,
  assignUserTypeWithCode,
  requestSignatureDev,
  sendWelcomeEmail,
  fetchPartnerDetails,
  fetchEnterpriseData,
  fetchEnterpriseAddress,
  fetchEnterpriseDenominations,
  giveFeedback,
  reportBug,
  getFile,
  fetchHelpArticles,
  fetchHelpCategories,
  incrementHelpArticleReadCount,
  downloadSignedDocument,
};
